import { Institution } from "./Institution"
import { Shelter } from "./Shelter"

export interface DogSummary {
    id: number,
    name: string,
    breed: string,
    breedCd: string,
    genderCd: string,
    ageCd: string,
    sizeCd: string,
    colorCd: string,
    institutionRefId: number,
    shelterRefId: number,
    createTs: string,
    photoId?: number,
}

export interface IDogDetail {
    id: number,
    name: string,
    primaryBreed?: string,
    secondaryBreed?: string,
    gender: string,
    age: string,
    yearsMonths: string,
    size: string,
    color: string,
    activeOffenses?: string,
    progress?: string,
    photoIds: number[],
    institution: Institution,
    shelter: Shelter,
}




export interface Dog {
    id: number,
    name: string,
    gender: string,
    genderCd: string,
    genderDesc: string,
    age: string,
    ageCd: string,
    breedCd?: string,
    breed?: string,
    breed1?: string,
    breed2?: string,
    size?: string,
    sizeCd?: string,
    color?: string,
    colorCd?: string,
    birthDt?: number,
    offense: string,
    progress: string,
    institution: Institution,
    shelter: string,
    shelterAddLine1: string,
    shelterAddLine2: string,
    shelterAddCitystatezip: string,
    shelterContact: string,
    shelterContactPhone: string,
    shelterUrl: string,
    // institution: string,
    // institutionAddLine1: string,
    // institutionAddLine2: string,
    // institutionAddCitystatezip: string,
    photos: string[],
    photoId?: number
}

export enum FILTER_TYPE {
    BREED = 'breedCd',
    GENDER = 'genderCd',
    AGE = 'ageCd',
    SIZE = 'sizeCd',
    COLOR = 'colorCd',
    INSTITUTION = 'institutionRefId',
    SHELTER = 'shelterRefId',
    CUSTOM_VIEW = 'customView'
}

export const FILTER_KEY = {
    [FILTER_TYPE.BREED]: 'breed',
    [FILTER_TYPE.GENDER]: 'gender',
    [FILTER_TYPE.AGE]: 'age',
    [FILTER_TYPE.SIZE]: 'size',
    [FILTER_TYPE.COLOR]: 'color',
    [FILTER_TYPE.INSTITUTION]: 'institution',
    [FILTER_TYPE.SHELTER]: 'shelter'
} as const;